module.exports = __webpack_public_path__ + "static/img/carousel-th-1.0e8ccf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel-th-1.png
// module id = nbyJ
// module chunks = 0